import {ChangeDetectionStrategy, ChangeDetectorRef, Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {StudentSummaryService} from '../../../../student-summary.service';
import {CardMembershipCodes} from '../card-membership-codes';

@Component({
    selector: 'app-membership-code-details-modal',
    templateUrl: './membership-code-details-modal.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    styleUrls: ['./membership-code-details-modal.component.css']
})
export class MembershipCodeDetailsModalComponent implements OnInit {
    RSNY_ID: number;
    membershipDetails: CardMembershipCodes[] = [];
    membershipCode: string;
    // Angular Material Table
    displayedColumns: string[] = ['startDate', 'endDate', 'code', 'updatedBy'];
    constructor(@Inject(MAT_DIALOG_DATA) public data: any, private studentSummaryService: StudentSummaryService, private cdr: ChangeDetectorRef, private dialogRef: MatDialogRef<MembershipCodeDetailsModalComponent>) {
    }

    ngOnInit() {
        this.RSNY_ID = this.data.RSNY_ID;
        this.membershipCode = this.data.membershipCode;
        this.getMembershipCodes();
    }

    getMembershipCodes() {
        this.studentSummaryService.getMembershipCodes(this.RSNY_ID).subscribe((response) => {
            if (response.ok) {
                this.membershipDetails = response.body;
                // Manually trigger change detection
                this.updateView();
            }
        });
    }

    updateView() {
        this.cdr.detectChanges();
    }

    closeClick() {
        this.dialogRef.close();
    }

}
